<template>
  <div class="bidButtonBidContainer">
    <!-- they are authenticated -->
    <div v-if="isAuthenticated">
      <!-- bidding is open -->
      <div v-if="itemBiddingStatus.is_bidding_open">
        <div>
          <!-- they are the high bidder and this is the current live lot -->
          <span v-if="itemIsCurrentHighBidder === true && itemBiddingStatus.current_live_lot === true">
            <button
              :disabled="'true'"
              class="bidButton disabledButton u-full-width"
            >
              {{ itemBidButtonText }}
            </button>
          </span>

          <!-- they are not the high bidder, or this is not the current live lot -->
          <div v-else>
            <!-- we are including the cancel button -->
            <div
              v-if="showCancelButton"
              class="bidButtonFullWidth"
            >
              <!-- show the action button -->
              <div class="bidButtonActionButton">
                <button
                  class="bidButton backgroundColorSuccess u-full-width"
                  :class="{ buttonPulse: (itemWaitingForConfirmation) }"
                  @click="placeBid('place_bid')"
                >
                  {{ itemBidButtonText }}
                </button>
              </div>

              <!-- show the cancel button -->
              <div class="bidButtonCancelButton">
                <span
                  v-if="showCancelButton"
                  class="cancelButton"
                  @click="cancelBid"
                >Cancel</span>
              </div>
            </div>

            <!-- we are not including the cancel button -->
            <div v-else>
              <div class="bidButtonActionButton">
                <!-- show the action button (with loader) -->
                <button
                  v-if="typeof (apiPending.place_bid) !== 'undefined'"
                  class="disabledButton bidButton u-full-width"
                  disabled="disabled"
                >
                  <span class="loading" />
                </button>
                <button
                  v-else
                  class="bidButton backgroundColorSuccess u-full-width"
                  @click="placeBid('place_bid')"
                >
                  {{ itemBidButtonText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- bidding has closed -->
      <div v-else>
        <!-- show the disabled button -->
        <div class="bidButtonActionButton">
          <button
            :disabled="'true'"
            class="bidButton disabledButton u-full-width"
          >
            {{ itemBidButtonText }}
          </button>
        </div>
      </div>
    </div>

    <!-- they are not authenticated -->
    <div v-else>
      <div class="bidButtonActionButton">
        <button
          class="bidButton backgroundColorDefault u-full-width"
          @click="expandSignIn"
        >
          Sign in
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {

	name: 'BidButton',

	components: {
	},

	props: [
		'item_id',
		'bidAmount',
		'showCancelButton',
		'Card',
		'assume_customer',
		'primaryPhone',
		'secondaryPhone'
	],

	data () {
		return {
			add_card: false,
			agree_to_terms: false
		}
	},

	computed: {

		itemIsTelephoneBid: function () {
			return this.$store.getters.itemIsTelephoneBid(this.item_id)
		},

		itemWaitingForConfirmation: function () {
			return this.$store.getters.itemWaitingForConfirmation(this.item_id)
		},

		itemRequiresCard: function () {
			return this.$store.getters.itemRequiresCard(this.item_id)
		},

		itemWaitingForAgreement: function () {
			return this.$store.getters.itemWaitingForAgreement(this.item_id)
		},

		isAuthenticated: function () {
			return this.$store.getters.isAuthenticated
		},

		itemBiddingStatus: function () {
			return this.$store.getters.itemBiddingStatus(this.item_id)
		},

		itemBidButtonText: function () {
			return this.$store.getters.itemBidButtonText(this.item_id)
		},

		apiPending: function () {
			return this.$store.getters.apiPending
		},

		apiResponse: function () {
			return this.$store.getters.apiResponse
		},

		itemIsCurrentHighBidder: function () {
			return this.$store.getters.itemIsCurrentHighBidder(this.item_id)
		},

		itemHasPendingBid: function () {
			return this.$store.getters.itemHasPendingBid(this.item_id)
		}

	},

	methods: {

		resetPhoneForm: function () {
			this.$emit('resetPhoneForm')
		},

		cancelBid: function () {
			this.$emit('resetForm')
		},

		isProfileCompleted() {
			if (this.$store.state.customer.first_name === null ||
				this.$store.state.customer.last_name === null ||
				this.$store.state.customer.phone === null ||
				this.$store.state.customer.billing_street_address === null ||
				this.$store.state.customer.billing_city === null ||
				this.$store.state.customer.billing_state === null ||
				this.$store.state.customer.billing_zip === null ) {

				this.$store.dispatch('showModal', {
					'component': 'SignIn',
					'props': {
						showUpdateAccount: true
					}
				});

				return false;
			}

			return true;
		},

		placeBid (context) {
			if (! this.isProfileCompleted()) {
				return false;
			}

			let payload = {
				'inventory_id': this.item_id,
				'confirmed': this.itemWaitingForConfirmation,
				'auction_id': this.itemBiddingStatus.auction_id,
				'bid_amount': this.bidAmount,
				'primary_phone': this.primaryPhone,
				'secondary_phone': this.secondaryPhone,
				'telephone_bid': this.itemIsTelephoneBid,
				'card': {
					'card_number': this.Card.card_number,
					'expire_month': this.Card.expire_month,
					'expire_year': this.Card.expire_year,
					'cvv2': this.Card.cvv2,
					'billing_address': this.Card.billing_address,
					'billing_zip': this.Card.billing_zip,
					'country': this.Card.country
				},
				'add_card': this.itemRequiresCard,
				'agree_to_terms': this.itemWaitingForAgreement
			}
			if (this.assume_customer) {
				payload.assume_customer = this.assume_customer
			}
			payload.context = context
			this.$store.dispatch('placeBid', payload)
				.then(response => {
					if (response && response.status === 200) {
						this.$store.dispatch('getCustomerComputedBidLimit', { inventory_id: this.item_id })
					}
				})
		},

		expandSignIn () {
			let payload = {
				'component': 'SignIn',
				'props': []
			}
			if (this.authenticated) {
				payload.component = 'AccountPage'
			}
			this.$store.dispatch('showModal', payload)
		}
	}
}
</script>

<style scoped>
</style>
